import type { ReactNode } from "react";

type AdminBannerProps = {
  children: ReactNode;
  color: "blue" | "green" | "orange" | "red";
  onClose: () => void;
};

export const AdminBanner = ({ children, color, onClose }: AdminBannerProps) => {
  return (
    <section className={`admin-banner admin-banner-${color}`}>
      <div className="admin-banner-content">{children}</div>
      <button
        aria-label="Close"
        className="admin-banner-close"
        onClick={onClose}
        type="button"
      >
        ✕
      </button>
    </section>
  );
};
